(function () {
    'use strict';

    angular.module("imApp").factory("vtLinkService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3793,
                    parameters: parms || {}
                });
            },
            listLinkTypes: function (parms) {
                return $ihttp.post({
                    method: 3794,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
